import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { motion, AnimatePresence } from 'framer-motion';
interface LayoutProps {
  children: React.ReactNode;
  currentPage: string;
  setCurrentPage: (page: string) => void;
}
export const Layout: React.FC<LayoutProps> = ({
  children,
  currentPage,
  setCurrentPage
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return <div className="min-h-screen flex bg-paper text-ink selection:bg-gold/30" data-id="element-72">
      <Sidebar currentPage={currentPage} setCurrentPage={setCurrentPage} isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} data-id="element-73" />

      <main className="flex-1 md:ml-64 min-h-screen relative" data-id="element-74">
        {/* Decorative background elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-75" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-cinnabar/5 rounded-full blur-3xl pointer-events-none" data-id="element-76" />

        <div className="max-w-5xl mx-auto px-4 py-20 md:py-12 md:px-8 relative z-10" data-id="element-77">
          <AnimatePresence mode="wait" data-id="element-78">
            <motion.div key={currentPage} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.3
          }} data-id="element-79">
              {children}
            </motion.div>
          </AnimatePresence>
        </div>
      </main>
    </div>;
};